import { render } from "./BetSummary.vue?vue&type=template&id=8c86472c&ts=true"
import script from "./BetSummary.vue?vue&type=script&lang=ts"
export * from "./BetSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__